exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.module-weiyitong[data-v-3b7b5f94] {\n  text-align: center;\n}\n.module-weiyitong .button[data-v-3b7b5f94] {\n  margin: 20px auto;\n  width: 80%;\n  height: 45px;\n  border-radius: 25px;\n  background: #ffdd41;\n  color: #1e834e;\n  font-size: 20px;\n}\n", ""]);

// exports
